import moment from 'moment';
export const relativeFutureTime = (date: Date, defaultResult = 'S/D') => {
  return date ? moment(date).endOf('day').fromNow() : defaultResult;
};
export const relativePassTime = (date: Date, defaultResult = 'S/D') => {
  return date ? moment(date).startOf('day').fromNow() : defaultResult;
};

export const fullTime = (date: Date, defaultResult = 'S/D') => {
  return date ? moment(date).format('LLLL') : defaultResult;
};

export const mediumDate = (date: Date, defaultResult = 'S/D') => {
  return date ? moment(date).format('LL') : defaultResult;
};
export const mediumTime = (date: Date, defaultResult = 'S/D') => {
  return date ? moment(date).format('hh:mm:ss A') : defaultResult;
};
